import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAccessToken } from '../useProfile';

type DeletePlannedWorkoutVariables = {
  workoutId: number;
};

export const useDeletePlannedWorkout = ({
  onSuccess,
}: {
  onSuccess?: () => void;
} = {}) => {
  const { data: accessToken } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ workoutId }: DeletePlannedWorkoutVariables) => {
      const response = await fetch(
        `${import.meta.env.REACT_APP_API_SERVICE_URI}/api/profile/plan/${workoutId}`,
        {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error('Failed to delete planned workout');
      }

      return response.text();
    },
    onSuccess: async (_data, { workoutId }) => {
      queryClient.removeQueries({
        queryKey: ['plannedWorkout', workoutId],
      });
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['racePlan'] }),
        queryClient.invalidateQueries({ queryKey: ['plannedWorkouts'] }),
      ]);
      onSuccess?.();
    },
  });
};
